<template>
<div class="flex items-center justify-center h-screen">
  <h1 v-if="loading">Подождите, идёт загрузка...</h1>
  <h1 v-else-if="completed">Оплата успешно завершена. Это окно можно закрыть.</h1>
  <h1 v-else-if="failed">Произошла ошибка. Вернитесь на предыдущий шаг и попробуйте ещё раз.</h1>
</div>
</template>

<script>
import axios from '@/zenky'
import CloudpaymentsProcessor from '@/components/payments/CloudpaymentsProcessor'
import InjectsSeo from '@/mixins/InjectsSeo'

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Оплата заказа'),
      description: 'Страница оплаты заказа',
    }
  },

  created() {
    this.loadOrder()
  },

  methods: {
    loadOrder() {
      this.failed = false
      this.loading = true

      axios.get(`orders/${this.$route.params.order}?token=${this.$route.params.token}&with=payments`)
        .then(({ data }) => {
          this.order = data.data
          this.loading = false
          this.failed = false

          const transaction = this.order.payments
            .find(transaction => transaction.status.id === 'pending' && transaction.method.id === 'cloudpayments')

          if (!transaction) {
            this.loadTransaction()
          } else {
            this.transaction = transaction
            this.displayWidget()
          }
        })
        .catch(err => {
          this.loading = false
          this.failed = true
          this.goToStatusPage('failed')
        })
    },

    loadTransaction() {
      this.failed = false
      this.loading = true

      const payload = {
        method: 'cloudpayments',
        amount: this.order.total_price.trimmed,
        save_card: false,
      }

      axios.post(`orders/${this.order.id}/payments/pending?token=${this.order.token}`, payload)
        .then(({ data }) => {
          this.transaction = data.data
          this.loading = false
          this.failed = false

          this.displayWidget()
        })
        .catch(err => {
          this.loading = false
          this.failed = true
          this.goToStatusPage('failed')
        })
    },

    displayWidget() {
      const processor = new CloudpaymentsProcessor(
        document,
        this.transaction,
        this.order.id,
        this.order.token
      )

      processor.start()
        .then(() => {
          this.goToStatusPage('success')
          this.completed = true
        })
        .catch(err => {
          this.goToStatusPage('failed')
        })
    },

    goToStatusPage(status) {
      const route = this.$router.resolve({
        name: 'payment.cloudpayments.status',
        params: {
          status,
          order: this.$route.params.order,
          token: this.$route.params.token,
        }
      })

      location.href = route.href
    },
  },

  data() {
    return {
      loading: false,
      failed: false,
      completed: false,
      order: null,
      transaction: null,
    }
  }
}
</script>
